import { ResourcesController } from './ResourcesController'

export { ResourcesController }

import { Resources } from './Resources'
import { Resource } from './Resource'

export { Resources, Resource }
